'use client';

import { useProfile } from '@/components/providers/profile-provider';
import { Card, CardContent } from '@/components/ui/card';
import { ChevronLeft } from 'lucide-react';
import { useRouter } from 'nextjs-toploader/app';
import { TransactionItem } from './transaction-item';
export default function RedeemedAmounts({
  onClick
}: {
  onClick?: () => void;
}) {
  const router = useRouter();
  const {
    withdrawals
  } = useProfile();
  const transactions = withdrawals || [];
  return <div className="min-h-screen w-full bg-gray-100 p-4 scrollbar-track-transparent md:min-h-full md:w-[400px] md:rounded-xl" data-sentry-component="RedeemedAmounts" data-sentry-source-file="redeemed-amount.tsx">
      <button type="button" onClick={onClick || (() => router.back())} className="mb-5  flex items-center gap-2">
        <ChevronLeft className="size-6" data-sentry-element="ChevronLeft" data-sentry-source-file="redeemed-amount.tsx" />
        <h1 className="text-2xl font-semibold">Redeemed amounts</h1>
      </button>
      <Card className="mx-auto  h-[calc(100vh-12vh)] max-w-md overflow-y-scroll " data-sentry-element="Card" data-sentry-source-file="redeemed-amount.tsx">
        <CardContent className="divide-y" data-sentry-element="CardContent" data-sentry-source-file="redeemed-amount.tsx">
          {(!transactions || transactions.length === 0) && <div className="flex  flex-col items-center justify-center p-5 text-center">
              <p className="text-base text-neutral-600">
                You haven't Redeemed any amount
              </p>
            </div>}
          {transactions.map((transaction, index) => <TransactionItem key={index} transaction={transaction} />)}
        </CardContent>
      </Card>
    </div>;
}